import { Component } from '@angular/core'

@Component({
    selector: 'UserManagementLayout',
    template: `
      <router-outlet></router-outlet>
  `
})

export class UserManagementLayoutComponent { }
